import * as Sentry from "@sentry/browser";
var LOGGER_NAME = "Sentry";
var logError = function (error, data) {
    Sentry.withScope(function (scope) {
        scope.setExtra("data", data);
        Sentry.captureException(error);
    });
};
var logInfo = function (info, data) {
    Sentry.withScope(function (scope) {
        scope.setExtra("data", data);
        Sentry.captureMessage(info);
    });
};
var logWarning = function (warning, data) {
    Sentry.withScope(function (scope) {
        scope.setLevel(Sentry.Severity.Warning);
        scope.setExtra("data", data);
        Sentry.captureException(warning);
    });
};
export default {
    id: LOGGER_NAME,
    Logger: {
        error: logError,
        info: logInfo,
        warning: logWarning,
    },
};
